import noodleDocumentsClient, { type ApiDefinition } from '@/tsClient/servers/noodleDocuments';
import buildPath from '@/tsClient/utilities/buildPath';

type THIS_API = ApiDefinition['/auth/document-access-token']['POST'];
type Input = THIS_API['body'];
type Output = THIS_API['response'];

const getDocumentAccessToken = async (body: Input): Promise<Output> => {
  const path = buildPath<THIS_API>('/auth/document-access-token');
  const response = await noodleDocumentsClient.post(path, body);
  return response.data;
};

export default getDocumentAccessToken;
